import React, { useEffect } from 'react';
import Chatbot from '../../components/Chatbot';

export default function ChatPage() {
  useEffect(() => {
    document.title = "Ask Austrian - Austrian Process";
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    const previousCanonical = canonicalLink ? canonicalLink.getAttribute('href') : '';
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://www.austrianprocess.com/ask-austrian');
    }
    return () => {
      if (canonicalLink && previousCanonical) {
        canonicalLink.setAttribute('href', previousCanonical);
      }
    };
  }, []);

  return <Chatbot />;
}